import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\FetchModelNotificationsByModelController::__invoke
* @see app/Http/Controllers/ModelNotification/FetchModelNotificationsByModelController.php
* @route '/api/model-notification/by-model'
*/
const FetchModelNotificationsByModelController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchModelNotificationsByModelController.url(options),
    method: 'get',
})

FetchModelNotificationsByModelController.definition = {
    methods: ["get","head"],
    url: '/api/model-notification/by-model',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ModelNotification\FetchModelNotificationsByModelController::__invoke
* @see app/Http/Controllers/ModelNotification/FetchModelNotificationsByModelController.php
* @route '/api/model-notification/by-model'
*/
FetchModelNotificationsByModelController.url = (options?: RouteQueryOptions) => {
    return FetchModelNotificationsByModelController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\FetchModelNotificationsByModelController::__invoke
* @see app/Http/Controllers/ModelNotification/FetchModelNotificationsByModelController.php
* @route '/api/model-notification/by-model'
*/
FetchModelNotificationsByModelController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchModelNotificationsByModelController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ModelNotification\FetchModelNotificationsByModelController::__invoke
* @see app/Http/Controllers/ModelNotification/FetchModelNotificationsByModelController.php
* @route '/api/model-notification/by-model'
*/
FetchModelNotificationsByModelController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchModelNotificationsByModelController.url(options),
    method: 'head',
})

export default FetchModelNotificationsByModelController